.label {
  color: light-dark(var(--mantine-color-secondary-5), var(--mantine-color-primaryDark-4));
  font-family: Serif-Font, serif;
  font-size: var(--mantine-font-size-sm);
}

.description {
  font-family: Serif-Font, serif;
  white-space: pre;
}
